import Login from '../components/Login'

export default [
    { path: '/auth/login', name: 'Login', component: Login },
    { path: '/auth/logout', redirect: '/auth/login' },
    { path: '/login', redirect: '/auth/login' }
]



// WEBPACK FOOTER //
// ./src/modules/Auth/routes/index.js